var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.getClass() }, [
    _c("div", [
      _c("span", [
        _vm._v(
          _vm._s(_vm.$t("total")) +
            ": " +
            _vm._s(_vm.bodyTotal || _vm.resultsList.length || 0)
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "results-table-header-container" }, [
      _c(
        "tr",
        _vm._l(_vm.headerItems, function (item, index) {
          return _c(
            "th",
            {
              key: "tableHeader_" + index,
              class: [item.name, _vm.containerCls(item)],
              on: {
                click: function ($event) {
                  return _vm.setSort(item)
                },
              },
            },
            [
              _c("span", [_vm._v(_vm._s(_vm.$t(item.title)))]),
              _c("i", { class: _vm.triangleDirection(item) }),
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.enableFilterBar
        ? _c(
            "tr",
            {
              attrs: { id: "result-table-filter-panel" },
              on: {
                keydown: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.keydownEvent.apply(null, arguments)
                },
              },
            },
            _vm._l(_vm.headerItems, function (item, index) {
              return _c(
                "th",
                {
                  key: "headerFiler_" + index,
                  class: ["search-content", item.name, _vm.containerCls(item)],
                },
                [
                  _c("SearchFilter", {
                    attrs: {
                      inputType: item.inputType,
                      type: item.name,
                      options: _vm.getOptions(item, item.options) || [],
                      customLabel: item.customLabel,
                      secondtype: item.style,
                      onchange: _vm.changeSearchItem,
                      value: _vm.passvalue(item),
                      multiple: item.multiple,
                      cls: item.style + "_" + item.name,
                      searchable: item.searchable,
                    },
                  }),
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { ref: "resultsTable", staticClass: "results-table-content-container" },
      [
        _vm._l(_vm.resultsList, function (item, index) {
          return _c(
            "tr",
            { key: "tablelist_" + index },
            _vm._l(_vm.headerItems, function (header, i) {
              return _c(
                "td",
                {
                  key: "tableCell_" + i,
                  class: [header.name, _vm.containerCls(header)],
                },
                [
                  i === 0 && _vm.withCheckbox && item.id
                    ? [
                        _c(
                          "span",
                          {
                            staticClass: "popover-container",
                            attrs: {
                              title: _vm.checkboxCheck(item)
                                ? _vm.$t("hint.contact.hintEmptyContact")
                                : null,
                            },
                          },
                          [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.selectCheckbox,
                                  expression: "selectCheckbox",
                                },
                              ],
                              attrs: {
                                type: "checkbox",
                                disabled: _vm.checkboxCheck(item),
                              },
                              domProps: {
                                value: item,
                                checked: Array.isArray(_vm.selectCheckbox)
                                  ? _vm._i(_vm.selectCheckbox, item) > -1
                                  : _vm.selectCheckbox,
                              },
                              on: {
                                change: [
                                  function ($event) {
                                    var $$a = _vm.selectCheckbox,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = item,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.selectCheckbox = $$a.concat([
                                            $$v,
                                          ]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.selectCheckbox = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.selectCheckbox = $$c
                                    }
                                  },
                                  function ($event) {
                                    _vm.selectTableItems &&
                                      _vm.selectTableItems(_vm.selectCheckbox)
                                  },
                                ],
                              },
                            }),
                          ]
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      class: _vm.getItemClass(item, header),
                      on: {
                        click: function ($event) {
                          return _vm.clickTableItem(item, header)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.getData(item, header)) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                2
              )
            }),
            0
          )
        }),
        _vm._v(" "),
        !_vm.resultsList.length
          ? _c("div", { staticClass: "empty-results" }, [
              _vm._v(
                "\n      " + _vm._s(_vm.$t("hint.contactSearch")) + "\n    "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.hasMore
          ? _c(
              "HKLLoadMore",
              _vm._g(
                { attrs: { watchElement: _vm.$refs.resultsTable } },
                _vm.$listeners
              )
            )
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }